import classNames from 'classnames'
import { forwardRef, HTMLAttributes, useEffect } from 'react'
import ReactDOM from 'react-dom'

import styles from './overlay.module.scss'

export interface OverlayProps extends HTMLAttributes<HTMLDivElement> {
  children?: never
  className?: string
  visible?: boolean
}

export const Overlay = forwardRef<HTMLDivElement, OverlayProps>(function Overlay(
  props,
  forwardedRef
) {
  const { className, visible = true, ...rest } = props

  const classes = classNames(
    styles.overlay,
    {
      [styles.overlayVisible]: visible,
    },
    className
  )

  useEffect(() => {
    document.body.style.overflow = 'hidden'

    return () => {
      document.body.style.overflow = 'visible'
    }
  }, [])

  return ReactDOM.createPortal(
    <div
      data-aria-hidden="true"
      aria-hidden="true"
      {...rest}
      className={classes}
      ref={forwardedRef}
    />,
    document.body
  )
})
